import './styles.css';

import React, {Fragment, Component} from 'react';
import PropTypes from "prop-types";
import Gutter from '../Gutter/Gutter';

const createMarkup = (item) => {
    return {__html: item};
}

const MyComponent = (item) => {
    return <div  dangerouslySetInnerHTML={createMarkup(item)} />;
}


class InformationLabelContentList extends Component {

    componentDidMount() {

        window.onClickLinks = (value) => {
            this.onClickLinks(value);
        };
        
    }

    onClickLinks = (value) => {
        this.props.onClickLinks ? this.props.onClickLinks(value) : null;
    };

    render() {
        let infoLabelContentListContent = null;

        if(this.props.infoLabelContentListContent && this.props.infoLabelContentListContent.length && this.props.infoLabelContentListContent.length > 1) {

            infoLabelContentListContent = this.props.infoLabelContentListContent.map((item, index) => {

                if(index < this.props.infoLabelContentListContent.length - 1) {
                    return (
                        <Fragment>
                            <div 
                            style={this.props.customStyleInformationLabelContentList} 
                            className="information-label-content">{MyComponent(item)}</div>
                            {/* <br /> */}
                            <Gutter height={10}/>
                            {
                                this.props.removeSecondLineBreak ?
                                    null
                                    :
                                    // <br />
                                    <Gutter height={10}/>
                            }

                        </Fragment>
                    )
                }

                else {
                    return <div 
                            style = {this.props.customStyleInformationLabelContentList} 
                            className="information-label-content"
                        >
                            {MyComponent(item)}
                        </div>
                }

            });
        }
        else if(this.props.infoLabelContentListContent && this.props.infoLabelContentListContent.length && this.props.infoLabelContentListContent.length === 1) {
            infoLabelContentListContent = MyComponent(this.props.infoLabelContentListContent[0]);
        }

        return (

            <div style={this.props.customStyleInformationLabelContentList} className="information-label-content-list">{infoLabelContentListContent}</div>
        )
    }


};

InformationLabelContentList.propTypes = {
    infoLabelContentListContent: PropTypes.string.isRequired
};


InformationLabelContentList.defaultProps = {
    removeSecondLineBreak: true
};

export default InformationLabelContentList;



// WEBPACK FOOTER //
// ./src/components/InformationLabelContentList/InformationLabelContentList.js